import React, {createContext, useState, useEffect, useContext} from 'react';
import axios from 'axios';
import {API_BASE_URL, API_KEY} from "../config/config";
import {AuthContext} from "./authContext";

const HomeContext = createContext(null);

const HomeProvider = ({ children }) => {
	const {visitor} = useContext(AuthContext);

	const [slidePreThreadsLoading, setSlidePreThreadsLoading] = useState(false);
	const [slidePreThreads, setSlidePreThreads] = useState(null);

	const [relatedThreadsLoading, setRelatedThreadsLoading] = useState(false);
	const [relatedThreads, setRelatedThreads] = useState(null);

	const fetchSlidePreThreads = async () => {
		if (!visitor) return;

		if (slidePreThreadsLoading) return; // Loading

		if (slidePreThreads !== null) return; // Already loaded

		try {
			setSlidePreThreadsLoading(true);

			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/react-home/slide-pre-threads`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
				},
				withCredentials : true
			};

			axios
				.request(config)
				.then((response) => {
					let threads = response.data.threads;
					if (typeof threads === "object") {
						threads = Object.values(threads);
					}

					setSlidePreThreads(threads);
					setSlidePreThreadsLoading(false);
				});
		} catch (error) {
			console.error('Failed to fetch slide premium threads:', error);
			setSlidePreThreadsLoading(false);
		}
	};

	const fetchRelatedThreads = async () => {
		if (!visitor) return;

		if (relatedThreadsLoading) return; // Loading

		if (relatedThreads !== null) return; // Already loaded

		try {
			setRelatedThreadsLoading(true);

			let config = {
				method: 'get',
				maxBodyLength: Infinity,
				url: `${API_BASE_URL}/react-home/related-threads`,
				headers: {
					'XF-Api-Key': API_KEY,
					'XF-Api-User': visitor.user_id,
				},
				withCredentials : true
			};

			axios
				.request(config)
				.then((response) => {
					let threads = response.data.threads;
					if (typeof threads === "object") {
						threads = Object.values(threads);
					}

					setRelatedThreads(threads);
					setRelatedThreadsLoading(false);
				});
		} catch (error) {
			console.error('Failed to fetch related threads:', error);
			setRelatedThreadsLoading(false);
		}
	};

	useEffect(() => {
		if (visitor) {
			fetchSlidePreThreads();
			fetchRelatedThreads();
		}
	}, [fetchRelatedThreads, fetchSlidePreThreads, visitor]);

	return (
		<HomeContext.Provider value={{
			slidePreThreads, slidePreThreadsLoading,
			relatedThreads, relatedThreadsLoading
		}}>
			{children}
		</HomeContext.Provider>
	);
};

export { HomeContext, HomeProvider };
